import script from "./PrixList.vue?vue&type=script&setup=true&lang=js"
export * from "./PrixList.vue?vue&type=script&setup=true&lang=js"

import "./PrixList.vue?vue&type=style&index=0&id=27dc1030&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27dc1030"]])

export default __exports__